// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.object("GiftLog", {
  id: __t.u64(),
  senderId: __t.u64(),
  receiverId: __t.u64(),
  giftType: __t.string(),
  amount: __t.i64(),
  itemId: __t.option(__t.u64()),
  createdAt: __t.u64(),
});


